import { render, staticRenderFns } from "./OperatoreMain.vue?vue&type=template&id=3daafcc6&scoped=true"
import script from "./OperatoreMain.vue?vue&type=script&lang=js"
export * from "./OperatoreMain.vue?vue&type=script&lang=js"
import style0 from "./OperatoreMain.vue?vue&type=style&index=0&id=3daafcc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daafcc6",
  null
  
)

export default component.exports